export const PRICE_THRESHOLD = 20.0; // 价格分界点
export const DISCOUNT_AMOUNT = 10.0; // 折扣金额
export const FREE_SHIPPING_THRESHOLD = 100.0; // 后续可能用到的免邮门槛
